import { attach, createEvent, sample } from 'effector'

import { getRegisterInfo } from '@portal/client-info'

import { portalProfileAPI } from '@/entities/profile/portal'
import { getPortalAPIErrorMessage } from '@/shared/api/portal/error-message'
import { $i18n, $lang } from '@/shared/lib/i18n'
import { toast } from '@/shared/lib/toast'
import { type NotificationArgs, showNotificationFx } from '@/shared/ui'
import { modal } from '@/shared/ui/modal'

export const googlePairInit = createEvent<{ accessToken: string }>()

const googlePairFx = attach({
    effect: portalProfileAPI.pairGoogleAdd,
    source: $lang,
    mapParams: ({ accessToken }: { accessToken: string }, lang) => ({
        access_token: accessToken,
        register_info: getRegisterInfo(lang),
    }),
})

sample({
    clock: googlePairInit,
    target: googlePairFx,
})

sample({
    clock: googlePairFx.done,
    fn: (): NotificationArgs => ({ notification: 'account_linked_google' }),
    target: [modal.closeAll, showNotificationFx],
})

sample({
    clock: googlePairFx.fail,
    source: $i18n,
    fn: ({ i18n }, { error }) => ({ message: getPortalAPIErrorMessage(error, i18n) }),
    target: toast.errorFx,
})
